import Api from './api';

const PartidoService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/partido/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/partido/buscar?${params}`)
        return response
    }
}

export default PartidoService;